import React from 'react';
import { connect } from 'react-redux';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import LiveStatsCard from './live-stats-card';

class LiveStatsCardContainer extends React.Component {
    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.PLAYERS);
        ScoringLoader.subscribe(endpointNames.COURSE);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.PLAYERS);
        ScoringLoader.unsubscribe(endpointNames.COURSE);
    }

    render() {
        return <LiveStatsCard {...this.props} />;
    }
}

const mapStateToProps = (state) => {
    return ({
        sitecorePlayers: state.scoring[endpointNames.PLAYERS],
        scoringCourse: state.scoring[endpointNames.COURSE]
    });
};

export default connect(
    mapStateToProps,
    null
)(LiveStatsCardContainer);
